import { useInfiniteQuery } from "@tanstack/react-query";
import { agencySaleDetail } from "../../services/agencies-sales-details";

export const AGENCIES_SALES_DETAILS_QUERY_KEY = "getAgenciesSalesDetails";

const PAGE_SIZE = 20;

export interface SalesHistoryFilters {
  userId?: number;
  dateInitial?: string;
  dateFinal?: string;
}

// Histórico de vendas do reseller com scroll infinito. O backend escopa por
// conta própria (agency_id = ctx.userId) e ordena id DESC (mais novo -> mais
// antigo). Sem filtros = últimos mais recentes. `skip` avança de PAGE_SIZE em
// PAGE_SIZE; quando uma página volta com menos que PAGE_SIZE, acabou.
export const useGetAgenciesSalesDetails = (
  filters: SalesHistoryFilters = {},
  enabled = true
) => {
  const query = useInfiniteQuery({
    queryKey: [AGENCIES_SALES_DETAILS_QUERY_KEY, filters],
    enabled,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      agencySaleDetail.getList({
        take: PAGE_SIZE,
        skip: pageParam as number,
        ...filters,
      }),
    getNextPageParam: (lastPage, allPages) => {
      const count = lastPage?.data?.length ?? 0;
      if (count < PAGE_SIZE) {
        return undefined;
      }
      return allPages.length * PAGE_SIZE;
    },
  });

  const sales = query.data?.pages.flatMap((page) => page?.data ?? []) ?? [];

  return {
    sales,
    isLoading: query.isLoading,
    isFetching: query.isFetching,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    refetch: query.refetch,
  };
};
